export default __webpack_public_path__ + "static/media/Emed4u(koti)devices.71bfdd52.png";